import { sendRequest } from 'best-modules/vue-utils'

type HistoryRow = {
  id: number
  userName: unknown
  dateTo: string | null
  name: string | null
  oldValue: unknown
  newValue: unknown
}

type StatusHistoryDictionaryItem = {
  id: number
  name: string
}

type StatusHistoryResponsible = {
  id: number
  name?: string | null
  surname?: string | null
  patronymic?: string | null
  photo?: string | null
}

type StatusHistoryRow = {
  id: number
  created_at: string
  comment: string | null
  oldStatus: StatusHistoryDictionaryItem | null
  newStatus: StatusHistoryDictionaryItem | null
  oldEntityType?: StatusHistoryDictionaryItem | null
  newEntityType?: StatusHistoryDictionaryItem | null
  responsible: StatusHistoryResponsible | null
}

type StatusHistoryRequest = (
  _entityId: number | string
) => Promise<StatusHistoryRow[]>

const orderHistory = (orderId: number | string): Promise<HistoryRow[]> => {
  return sendRequest({
    name: 'orderHistory',
    method: 'get',
    url: `/json/history/${orderId}/order`,
  })
}

const incidentStatusHistory = (
  incidentId: number | string
): Promise<StatusHistoryRow[]> => {
  return sendRequest({
    name: 'incidentStatusHistory',
    method: 'get',
    url: `/json/incident/logStatus/byIncident/${incidentId}`,
  })
}

export { incidentStatusHistory, orderHistory }
export type { HistoryRow, StatusHistoryRequest, StatusHistoryRow }
